module.exports = __webpack_public_path__ + "static/media/enviar_imagem.e7f98904.svg";